import React from 'react';

const ConditionalRender = React.memo((props) => {
    return props.visible ? props.children : null
});

export default ConditionalRender